module.exports = __webpack_public_path__ + "img/sp_app_notice_parents.9d76e90e.png";